import { Check } from 'lucide-react';

import { siteConfig } from '@/config/site';
import { SectionHeading } from '@/components/SectionHeading';

export function AboutSection() {
  return (
    <section id="about" className="container scroll-mt-24 py-20 md:py-28">
      <SectionHeading kicker="// about" title="The human behind the keys" />

      <div className="mt-10 grid items-start gap-12 md:grid-cols-2 md:gap-14">
        {/* Bio + values + skills */}
        <div className="space-y-5">
          {siteConfig.bio.map((paragraph, i) => (
            <p
              key={i}
              className={
                i === 0 ? 'text-lg leading-relaxed' : 'leading-relaxed text-muted-foreground'
              }
            >
              {paragraph}
            </p>
          ))}

          <ul className="space-y-2.5 pt-2">
            {siteConfig.values.map((value) => (
              <li key={value} className="flex items-start gap-2.5 text-sm">
                <Check className="mt-0.5 size-4 shrink-0 text-primary" />
                <span>{value}</span>
              </li>
            ))}
          </ul>

          <div className="flex flex-wrap gap-2 pt-3">
            {siteConfig.skills.map((skill) => (
              <span
                key={skill}
                className="rounded-full border bg-card px-3 py-1 font-mono text-xs text-muted-foreground transition-colors hover:border-primary/50 hover:text-primary"
              >
                {skill}
              </span>
            ))}
          </div>
        </div>

        {/* Terminal */}
        <div className="relative">
          <div className="absolute -inset-1 rounded-2xl bg-gradient-to-br from-primary/25 to-spark/15 blur-xl" />
          <div className="relative overflow-hidden rounded-xl border bg-card shadow-2xl">
            <div className="flex items-center gap-2 border-b bg-muted/50 px-4 py-3">
              <span className="size-3 rounded-full bg-destructive/70" />
              <span className="size-3 rounded-full bg-yellow-500/70" />
              <span className="size-3 rounded-full bg-green-500/70" />
              <span className="ml-2 font-mono text-xs text-muted-foreground">
                {siteConfig.handle}@node: ~
              </span>
            </div>
            <div className="space-y-4 p-5 font-mono text-[13px] leading-relaxed">
              {siteConfig.terminal.map((line, i) => (
                <div key={i} className="space-y-1">
                  <p>
                    <span className="mr-2 text-primary">$</span>
                    <span>{line.cmd}</span>
                  </p>
                  <p className="whitespace-pre-wrap text-muted-foreground">{line.out}</p>
                </div>
              ))}
              <p>
                <span className="mr-2 text-primary">$</span>
                <span className="inline-block h-4 w-2 translate-y-0.5 animate-pulse bg-primary" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
